import React, { useEffect, useState } from 'react';
import Web3 from 'web3';


import {
    ButtonProps
} from '@mui/material';


import LoadingButton from '@mui/lab/LoadingButton';
import './index.css';
import Footer from '../../components/footer';



import { styled } from '@mui/material/styles';
import axios from 'axios';
import { useSearchParams } from 'react-router-dom';
import useToken from '../../utils/useToken';
import ProjectsGrid from '../../components/projects';

const host_prefix: string = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000';


const ColorLoadingButton = styled(LoadingButton)
    <ButtonProps>(({ theme }) => ({
        color: theme.palette.getContrastText("#6e3f3f"),
        borderRadius: 2,
        marginTop: 100,
        justifyContent: 'center',
        backgroundColor: "#6e3f3f",
        '&:hover': {
            backgroundColor: "#110829",
        },
        "&:disabled": {
            backgroundColor: "#7c7c84",
        },
    }));



const Projects = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const organization_id = searchParams.get('organization');
    //console.log(`Project has received params: ${JSON.stringify(searchParams)}`);
    const { token, setToken } = useToken();
    let [projects, setProjects] = useState<[{
        "_id": string,
        "name": string,
        "github_url": string,
        "tags": string,
        "organization_id": string,
        "createdAt": string,
        "updatedAt": string,
        "__v": number,
        "description": string
    }]>();
    useEffect(() => {
        //fetchOrganizations(token);
        async function fetchProjects() {
            console.log('Making request to organizations endpoint');
            try {
                const options = {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                }
                axios.get(`${host_prefix}/api/projects?organization=${organization_id}`, options).then(async (res) => {
                    //console.log(res)
                    if (res.data && token) {

                        if (res.data.length > 0) {
                            //console.log(res.data)

                            setProjects(res.data);
                        }
                    }
                })
            } catch (error) {
                console.log('Welcome redirect error: ' + error);
            }
        }

        fetchProjects();
    }, []);


    if (projects) {
        //console.log(organizations)
        return (
            <React.Fragment>
                <body className="bg-image" >
                    <br /><br /><br /><br /><br />
                    <ProjectsGrid projects={projects} />
                    <Footer />
                </body>
            </React.Fragment>
        )
    } else {

        return (
            <React.Fragment>
                <body className="bg-image" >
                    <img src={require('./../../images/logo_cropped.png')} className="logo" />
                    <br />
                    <ColorLoadingButton
                        size="small"
                        type="submit"
                        loadingIndicator="Loading..."
                        variant="outlined"
                    >
                        Connect with Github
                    </ColorLoadingButton>
                    <Footer />
                </body>
            </React.Fragment>
        )
    }
}

export default Projects;